import Laboratory from 'builders/builderInternal/components/Laboratory';
import React from 'react';

export default function index() {
    return (
        <Laboratory />
    );
}
